
 <div class="barcodeContainer" style="height: 0;visibility: hidden;">
  <svg id="barcode" style="height: 0;"></svg>
</div>

<div class="genericPage">
  <br />
  <br />
  <div class="ui-g-12 ui-g-nopad">
    <h1 class="step-title">{{'voucherCouponsMg.titleList' | translate}}</h1>
  </div>
  <div class="ui-g-12 ui-g-nopad headerFilters" *ngIf="show.context">
    <br />
    <br />
    <div class="ui-g-3">
      <div class="ui-g-4 text-right">
        {{'voucherCouponsMg.filter_channel' | translate}}:
      </div>
      <div class="ui-g-8">
        <p-dropdown [filter]="true" [options]="selectChannel" optionLabel="label" [style]="{'width':'100%'}" [(ngModel)]="headerFilters.channel" (onChange)="onChangeChannel()"></p-dropdown>
      </div>
    </div>
    <div class="ui-g-3">
      <div class="ui-g-4 text-right">
        {{'voucherCouponsMg.filter_store' | translate}}:
      </div>
      <div class="ui-g-8">
        <p-dropdown [filter]="true" [options]="selectStore" optionLabel="label" [style]="{'width':'100%'}" [(ngModel)]="headerFilters.store" (onChange)="onChangeStore()"></p-dropdown>
      </div>
    </div>
    <div class="ui-g-3">
      <div class="ui-g-4 text-right">
        {{'voucherCouponsMg.show_expired' | translate}}:
      </div>
      <div class="ui-g-8">
        <p-checkbox
        class="ch-checkbox"
        [binary]="true"
        (onChange)="onChangeExpired()"
        [(ngModel)]="headerFilters.expired">
      </p-checkbox>
      </div>
    </div>

  </div>
  <div class="ui-g-12" *ngIf="show.context">

      <app-kontablenew title = "{{'voucherCouponsMg.titleList' | translate}}"
          id="couponListTable"
          [columns] = "[
          { field: 'eanCode', title: 'voucherCouponsMg.dt_title_eancode' },
          { field: 'eanDescription', title: 'voucherCouponsMg.dt_title_eandescription' },
          { field: 'voucherId', title: 'voucherCouponsMg.dt_title_idvoucher', filterType: customFilter, filterTemplate: voucherIdFilter },
          { field: 'barcodeNumber', title: 'voucherCouponsMg.dt_title_barcode', sortable: false, bodyTemplate: barcodeNumberTemplate },
          { field: 'cardId', title: 'voucherCouponsMg.dt_title_card', filterType: customFilter, filterTemplate: cardIdFilter },
          { field: 'customerName', title: 'voucherCouponsMg.dt_title_customer_name' },
          { field: 'customerSurname', title: 'voucherCouponsMg.dt_title_customer_surname' },
          { field: 'expireDate', title: 'voucherCouponsMg.dt_title_expirydate', bodyTemplate: expireDateTemplate, filterType: dateFilter},
          { field: 'issueTypeCode', title: 'voucherCouponsMg.dt_title_issuetype', bodyTemplate: issueTypeTemplate, filterType: customFilter, filterTemplate: issueFilter},
          { field: 'printed', title: 'voucherCouponsMg.dt_title_printed', bodyTemplate: printedTemplate, filterType: customFilter, filterTemplate: printedFilter},
          { field: 'value', title: 'voucherCouponsMg.dt_title_value', sortable: false },
          { field: 'voucherStateCode', title: 'voucherCouponsMg.dt_title_state', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter },
          { field: 'voucherTypeCode', title: 'voucherCouponsMg.dt_title_type', bodyTemplate: voucherTypeTemplate, filterType: customFilter, filterTemplate: typeFilter }
          ]"
          [paginationType]="paginationType"
          [showInfoButton]="true"
          [showGlobalFilter]="false"
          [(fireNewDataAvailable)]="newDataAvailable"
          [showReport]="false"
          [showDetailsButton]="false"
          [showAddButton]="false"
          [showDeleteButton]="false"
          [toolbarCustomButtons]="customButtons"
          [filterBySingleColumn]="!staticTable"
          [service]="srvVoucherCoupon"
          (onEdit)="edit($event)"
          (onInfo)="info($event)"
          (onClearFilters)="clearFilters()"
          #couponListTable>

        <ng-template #issueTypeTemplate data-testid="issueTypeTemplate" let-row>
          <span>{{getIssueType(row.issueTypeCode)}}</span>
        </ng-template>

        <ng-template #issueDateTemplate data-testid="issueDateTemplate" let-row>
          <span>{{getDate(row.issueDate)}}</span>
        </ng-template>

        <ng-template #expireDateTemplate data-testid="expireDateTemplate" let-row>
          <span>{{getDate(row.expireDate)}}</span>
        </ng-template>

        <ng-template #stateTemplate data-testid="stateTemplate" let-row>
          <span>{{getState(row.voucherStateCode)}}</span>
        </ng-template>

        <ng-template #voucherTypeTemplate data-testid="voucherTypeTemplate" let-row>
          <span>{{getVoucherType(row.voucherTypeCode)}}</span>
        </ng-template>

        <ng-template #barcodeNumberTemplate data-testid="barcodeNumberTemplate" let-row let-index>
          <span>{{row.barcodeNumber}} &nbsp;&nbsp;<i style="cursor:pointer;" *ngIf="row.barcodeNumber" class="fa fa-barcode" (click)="onClickVisualizzaBarcode(row.barcodeNumber)"></i></span>
        </ng-template>


        <ng-template #printedTemplate data-testid="printedTemplate" let-row>
          <span *ngIf="row.printed === true">{{'common.yes' | translate}}</span>
          <span *ngIf="row.printed === false">{{'common.no' | translate}}</span>
        </ng-template>

        <ng-template #issueFilter data-testid="issueFilter" let-col>
          <p-dropdown [options]="selectIssue" [(ngModel)]="model.issue" [style]="{'width':'100%'}" (onChange)="updateIssueFilter($event)"></p-dropdown>
        </ng-template>

        <ng-template #typeFilter data-testid="typeFilter" let-col>
          <p-dropdown [options]="selectType"  [(ngModel)]="model.type" [style]="{'width':'100%'}" (onChange)="updateTypeFilter($event)"></p-dropdown>
        </ng-template>

        <ng-template #printedFilter data-testid="printedFilter" let-col>
          <p-dropdown [options]="selectPrinted"  [(ngModel)]="model.printed" [style]="{'width':'100%'}" (onChange)="updatePrintedFilter($event)"></p-dropdown>
        </ng-template>

        <ng-template #stateFilter data-testid="stateFilter" let-col>
          <p-dropdown [options]="selectState"  [(ngModel)]="model.state" [style]="{'width':'100%'}" (onChange)="updateStateFilter($event)"></p-dropdown>
        </ng-template>

        <ng-template #cardIdFilter data-testid="cardIdFilter" let-col>
          <span class="customInputTextFilter" >
            <input class="customInputTextFilter" [(ngModel)]="model.cardId" id="cardIdFilter" type="text" pInputText class="form-control" (input)="updateCardIdFilter($event)" />
          </span>
        </ng-template>

        <ng-template #voucherIdFilter data-testid="voucherIdFilter" let-col>
          <span class="customInputTextFilter" >
            <input id="voucherIdFilter" type="text" pInputText [(ngModel)]="model.voucherId" class="form-control" (input)="updateVoucherIdFilter($event)" />
          </span>
        </ng-template>

      </app-kontablenew>
  </div>

</div>

<p-dialog header="Edit Voucher & Coupon" [(visible)]="show.editModal" [modal]="true" width="1000" [draggable]="false" [resizable]="false">
    <div *ngIf="show.editModal">
      <form [formGroup]="form" (ngSubmit)="onClickPerformEdit()">

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_serialCode' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.barcodeNumber}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_eanValue' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.eanCode}}<span *ngIf="eanDescription">&nbsp;- {{currentVoucherCoupon.eanDescription}}</span></label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_card' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.cardId}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_customer' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.customerDescription}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_issue' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{getDate(currentVoucherCouponDetail.issueDate)}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_expire' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{getDate(currentVoucherCouponDetail.expireDate)}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_type' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{getVoucherType(currentVoucherCouponDetail.voucherTypeCode)}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_emission' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{getIssueType(currentVoucherCouponDetail.issueTypeCode)}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_value' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.value}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_points' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.point}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_printed' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label>
                <p-checkbox
                class="ch-checkbox"
                [binary]="true"
                formControlName="printed">
              </p-checkbox>
              </label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_shortCode' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.shortCode}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_status' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <p-dropdown
                [ngClass]="!context.allowedChangeVoucherState ? 'dropdownDisabled' : ''"
                [options]="context.voucherStateList"
                [disabled]="!context.allowedChangeVoucherState"
                optionLabel="description"
                [style]="{ width: '100%' }"
                formControlName="status"
                [autoWidth]="false">
              </p-dropdown>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_idLayout' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.layoutId}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_template' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.templateId}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_eanValue' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <p-checkbox
                class="ch-checkbox"
                value="currentVoucherCouponDetail.allowRefund"
                [disabled]="true"
                [binary]="true"
              >
              </p-checkbox>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_loyalty' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.loyaltyDescription}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_promoType' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.promoIssueTypeDescription}}</label>
            </div>
          </div>
        </div>

        <div class="ui-g-12 ui-fluid">
          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_discountType' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.discountTypeDescription}}</label>
            </div>
          </div>

          <div class="ui-g-6  padding05">
            <div class="ui-g-6  padding05 text-right">
              <label>{{'voucherCouponsMg.details_voucher' | translate}}</label>
            </div>
            <div class="ui-g-6  padding05">
              <label class="inputDisabled">{{currentVoucherCouponDetail.parentVoucherDescription}}</label>
            </div>
          </div>
        </div>
        <div class="ui-dialog-footer">
          <button type="submit" style="margin-top: 20px;" styleClass="ui-button-info" pButton icon="fa fa-floppy-o" label="{{'common.save' | translate}}"></button>
        </div>
      </form>
    </div>

</p-dialog>

<p-dialog *ngIf="showBarcodeModal" header="Barcode" [(visible)]="showBarcodeModal" [modal]="true" [draggable]="true" position="top" [closable]="true">
  <img [src]="srcBarcode" alt="source Barcode" />
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg.component.html